import { GlobalFilterType, VendorSearchOption } from '../../config/types';
import { useLocation } from 'react-router-dom';
import React from 'react';
import { UserContext } from '../../provider/user';
import { TermsContext } from '../../provider/terms';
import { NotificationContext } from '../../reducer/notification';
import { useMutation } from '@apollo/client';
import { CREATE_FILTER_TRACKING } from '../../graphql/views/mutations';
import { isAdmin } from '../../helpers/users';
import { slugify } from '../../helpers/data';

type TFilterTracking = {
	filter_type: keyof GlobalFilterType | 'globalSearch';
	filter_value: string;
	category: string;
	tag: string;
	path: string;
	company_name: string;
	company_logo: string;
	user_id: string;
	user_name: string;
	user_avatar: string;
	user_role: string;
	user_company_id: string;
	user_company_name: string;
};

export const useFilterTracking = () => {
	const { pathname } = useLocation();

	const { user, company } = React.useContext(UserContext);
	const { terms } = React.useContext(TermsContext);
	const { dispatch: dispatchNotification } = React.useContext(NotificationContext);

	const [createFilterTracking] = useMutation(CREATE_FILTER_TRACKING);

	const filterTracking = async (
		filter: keyof GlobalFilterType | 'globalSearch',
		value: string | VendorSearchOption,
	) => {
		const data: TFilterTracking = {
			filter_type: filter,
			filter_value: typeof value === 'string' ? value : value.id,
			category:
				filter === 'category' && typeof value === 'string' ? terms[filter][value].name : '',
			tag: filter === 'tag' && typeof value === 'string' ? terms[filter][value].name : '',
			path: pathname,
			company_name: filter === 'company' && typeof value !== 'string' ? value.name : '',
			company_logo:
				filter === 'company' && typeof value !== 'string' ? value.featuredImage : '',
			user_id: user ? user?.uid : '',
			user_name: user ? `${user.firstName} ${user.lastName}` : '',
			user_avatar: user && !isAdmin(user) ? user.avatar : '',
			user_role: user ? user.role : 'anonymous',
			user_company_id: user && !isAdmin(user) ? user.companyId : '',
			user_company_name: user && company?.name ? company.name : '',
		};

		if (
			!(
				isAdmin(user) ||
				pathname.match(/^\/my-space/) ||
				pathname.match(/edit$/) ||
				(company && pathname.match(slugify(company.name)))
			)
		) {
			try {
				await createFilterTracking({ variables: data });
			} catch (error: any) {
				console.error(error);
				dispatchNotification({
					type: 'notification/SHOW_ERROR',
					payload: {
						message: error?.message ?? 'Unknown error',
					},
				});
			}
		} else {
			console.info('Production would track filter use here.');
		}
	};

	return { filterTracking };
};
